exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".event{height:50px;max-width:50px;cursor:pointer;font-size:12px;color:#fff;line-height:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:#0e9604}.more-link{cursor:pointer;padding-left:8px;padding-right:2px;color:rgba(0,0,0,.38);font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5404d212","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/vue-calendar/events-box.vue
// module id = 887
// module chunks = 0